// src/services/playerUtils.js
//
// Player-shape display helpers shared across desktop and mobile player surfaces.
// Drift across 4 formatHeight + 3 calculateAge implementations was reconciled
// here per Bible §14.test-infra.4 (revised at 3b1c7a31) + §14.dispatch.2.
//
// Consumers pass { missingValue } to match their surrounding UI's missing-value
// idiom:
//   - 'N/A' (default) for direct-JSX rendering with sibling 'N/A' fallbacks
//   - null for [...].filter(Boolean) array rendering
//   - '-' for InfoItem/ScoutingItem patterns with sibling placeholder-dash idiom
//
// Migration to consumers occurs in commit 8k.2.

export const formatHeight = (heightInches, { missingValue = 'N/A' } = {}) => {
  if (!heightInches) return missingValue;
  const feet = Math.floor(heightInches / 12);
  const inches = heightInches % 12;
  return `${feet}'${inches}"`;
};

export const calculateAge = (birthdate, { missingValue = 'N/A' } = {}) => {
  if (!birthdate) return missingValue;
  const birth = new Date(birthdate);
  if (isNaN(birth.getTime())) return missingValue;
  const today = new Date();
  let age = today.getFullYear() - birth.getFullYear();
  const monthDiff = today.getMonth() - birth.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
    age--;
  }
  return age;
};
